/*=========================================================================================
  File Name: module-usertax-actions.js
  Description: UserTax Module Actions
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

export default {
	UserList: function(state) {
		return state.UserList;
	},
	Total: function(state) {
		return state.Total;
	},
	userListLoaded: function(state) {
		return state.userListLoaded;
	},
	/**
	 * Trạng thái AmisConvertStatus của UserTax hiện tại (user đăng nhập + MST làm việc)
	 * Nguồn: currentUserTax được commit lúc login/đổi MST từ AppData.UserTax
	 * Trả về null nếu chưa có bản ghi (vd: luồng login không trả UserTax)
	 */
	currentUserTaxAmisConvertStatus: function(state) {
		const userTax = state.currentUserTax;
		return userTax ? userTax.AmisConvertStatus : null;
	}
};
